import { GUARD_ME_QUERY } from "@/features/guardme/graphql/guardme-query";
import { GuardMe } from "@/features/guardme/guardme";

export const Route = createFileRoute({
  component: GuardMe,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(GUARD_ME_QUERY, { id: params.id })
        .toPromise();
    }
  },
});
